module.exports = require("froala-editor/css/froala_style.min.css");